<template>
  <div class="lookServer main-container">
    <Tabs v-model="curNum" :animated="false" @on-click="tabClick">
      <TabPane label="基本资料" name="0">
        <div class="baseInfo" v-if="baseInfo && baseInfo.length > 0">
          <div class="btn" style="margin:20px 0">
            <Button type="primary" @click="downAllloadPdf">下载全部文档</Button>
          </div>
          <div v-if="baseInfoItems.length" class="baseInfoItemsList">
            <div v-for="(item,index) in baseInfoItems" :key="index" class="baseInfoItems">
              <div>
                <img src="@/static/images/product/pdf2.png" alt="" v-if="item.url.includes('pdf')">
                <img src="@/static/images/product/xls.png" alt="" v-if="item.url.includes('xls')">
              </div>
              <div class="itemName">{{ item.name }}</div>
              <div class="btn">
                <a :href="item.url" target="_blank" v-if="item.url.includes('pdf')">预览</a>
                <span @click="downloadFile(item)">下载</span>
              </div>
            </div>
          </div>
        </div>

        <no-data v-else></no-data>
      </TabPane>
      <TabPane label="产品海报" name="1">
        <div class="contentList" v-if="post && post.length > 0">
          <div v-for="(item, index) in post" :key="index" class="posterList" @mouseleave="control = false">
            <div class="poster">
              <img :src="item.url" :preview="_uid" :ref="'img' + index">
              <div class="posterEdit">
                <img src="@static/images/product/down.png" alt="" @click="$units.downloadFile(item.url,{},'GET',item.title+'.jpg')">
                <img src="@static/images/product/Twriting.png" alt="" @click="copywrite(item.copywriting)">
                <img src="@static/images/product/openImg.png" alt="" @click="$refs['img' + index][0].click()">
              </div>
              <div class="posterContent">
                <span>{{ item.copywriting }}</span>
              </div>
            </div>
            <div class="posterTitle">{{ item.title }}</div>
          </div>
        </div>
        <no-data v-else></no-data>
      </TabPane>
      <TabPane label="回执回访指引" name="2">
        <div v-if="returnData.receiptStatus && returnData.revisitStatus" class="panel">
          <div class="item1">本产品{{ getReturnStatus() }}</div>

          <div class="stepText" v-if="returnData.receiptStatus == '0'">
            <div class="title" style="font-weight: 800;">回执操作流程：</div>
            <div v-if="returnData.receiptDesc"><span v-for="(v, index) in returnData.receiptDesc.split('\n')" :key="index">{{ v }}<br /></span></div>
            <div v-else>暂无内容</div>
          </div>
          <div class="stepText" v-if="returnData.revisitStatus == '0'">
            <div class="title" style="font-weight: 800;">回访操作流程：</div>
            <div v-if="returnData.revisitDesc"><span v-for="(v, index) in returnData.revisitDesc.split('\n')" :key="index">{{ v }}<br /></span></div>
            <div v-else>暂无内容</div>
          </div>
        </div>
        <no-data v-else></no-data>
      </TabPane>
      <Button @click="$router.go(-1)" type="primary" ghost slot="extra">返回</Button>
    </Tabs>

  </div>
</template>

<script>
import { getProductMaterials, dowloadPdf, getPosts } from "@/api/httpList";
export default {
  components: {},
  props: {},
  data() {
    return {
      baseInfo: [
        {
          items: []
        }
      ],
      baseInfoItems:[],
      post: [],
      curNum: "0",
      returnData:{},
    };
  },
  computed:{ 
    hesiationType(){
      if(this.returnData.hesitateType == '1'){
        return '回执当日'
      }else if(this.returnData.hesiationType == '2'){
        return '回执次日'
      }else if(this.returnData.hesitateType == '3'){
        return '生效日期'
      }else{
        return ''
      }
    }
  },
  methods: {
    getReturnData(){
      this.$http({
        type: 'GET',
        url: '/buz/productBase/read/detail/v2',
        data: {
          id: this.$route.query.productId
        },
      }).then((resData) => {
        this.returnData = resData.data.productBase
      })
    },
    getReturnStatus(){
      let receiptStatus,revisitStatus
      if(this.returnData.receiptStatus == '0'){
        receiptStatus = '需要回执'
      }else if(this.returnData.receiptStatus == '-1'){
        receiptStatus = '无需回执'
      }else if(this.returnData.receiptStatus == '1'){
        receiptStatus = '默认回执成功'

      }else{
        receiptStatus = ''
      }
      if(this.returnData.revisitStatus == '0'){
        revisitStatus = '需要回访'
      }else if(this.returnData.revisitStatus == '-1'){
        revisitStatus = '无需回访'
      }else if(this.returnData.revisitStatus == '1'){
        revisitStatus = '回访成功'
      }else{
        revisitStatus = ''
      }
      if(receiptStatus && revisitStatus){
        return receiptStatus+'，'+revisitStatus
      }
      
    },
    downloadFile(item){
      let name
      if(item.url.includes('.pdf')){
        name = item.name+'.pdf'
      }else{
        name = item.name+'.xls'
      }
      this.$units.downloadFile(item.url,{},'GET',name)
    },
    // 文案复制
    copywrite(value) {
      let oInput = document.createElement("input");
      oInput.value = value;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$Message.success("复制成功");
    },
    preview(key) {
      console.log(this.$refs[key][0].click())
      // this.$refs[key]
    },
    // 下载
    download(url) {
      this.$units.downloadFile(url, {}, 'GET');
    },
    downAllloadPdf() {
      this.$units.downloadFile(`/buz/productMaterial/${this.productCode}/downloadAll`, {list:this.baseInfoItems}, 'POST');
    },
    tabClick(name) {
      if (name == 1) {
        //产品海报
        this.getPoster()
      } else {
        this.$http({
          url: '/buz/productMaterial/queryMaterials',
          type: 'GET',
          data: {
            productCode: this.$route.query.productCode,
            productId: this.$route.query.productId,
          }
        }).then(res => {
          this.baseInfo = res.data;
          this.baseInfoItems = []
          this.baseInfo.forEach(item=>{
            item.items.forEach(i=>{
              this.baseInfoItems.push(i)
            })
          })
        })
      }
    },
    getPoster(){
      this.$http({
            url: '/buz/cmsPoster/product/list',
            type: 'POST',
            data: {
              productCode: this.productCode,
            },
            apiPermissionCode : 'pro_1_3'
          }).then(res => {
            this.post = res.data;
            this.$previewRefresh();
          });
    }
  },
  created() { },
  mounted() {
    this.productCode = this.$route.query.productCode;
    this.curNum = this.$route.query.curNum || '0';
    this.tabClick(this.curNum)
    this.getReturnData()
  }
};
</script>
<style lang="scss" scoped>
@import "./promotional.scss";
</style>
